export default __webpack_public_path__ + "img/survey.fe9eb0f8.svg";